import { Observable, of } from 'rxjs';
import { DateTime } from 'luxon';
import { Valid } from 'luxon/src/_util';
import { IGraphCollection } from '../../model/dto/graph-collection.type';
import { generateAssetMock } from '../data/asset.generator.mock';

export class GraphCollectionApiServiceMock {

    public getGraphCollection(startDate: DateTime<Valid>, endDate: DateTime<Valid>, type: 'SUPPLY' | 'DEMAND' | 'GENERATION' | 'AVAILABILITY'): Observable<IGraphCollection[]> {
        return of([
            {
                id: '1',
                name: 'Power',
                type: 'type-test',
                category: 'Test',
                assets: [
                    generateAssetMock(startDate, endDate, 'CHP1', '#f54f4f', '1'),
                    generateAssetMock(startDate, endDate, 'CHP2', '#73AD02', '2'),
                    generateAssetMock(startDate, endDate, 'CHP3', '#34AADD', '3'),
                ],
            },
            {
                id: '2',
                name: 'Heat',
                type: 'type-test',
                category: 'Test',
                assets: [
                    generateAssetMock(startDate, endDate, 'CHP1', '#f54f4f', '1'),
                    generateAssetMock(startDate, endDate, 'CHP2', '#73AD02', '2'),
                    generateAssetMock(startDate, endDate, 'CHP3', '#34AADD', '3'),

                ],
            },

        ])
    }

    public getGraphCollectionV1(graphCollectionId: string, startDate: DateTime<Valid>, endDate: DateTime<Valid>): Observable<IGraphCollection> {
        return of({
            id: graphCollectionId,
            name: 'Power',
            type: 'type-test',
            category: 'Test',
            assets: [
                generateAssetMock(startDate, endDate, 'CHP1', '#f54f4f', '1'),
                generateAssetMock(startDate, endDate, 'CHP2', '#73AD02', '2'),
                generateAssetMock(startDate, endDate, 'CHP3', '#34AADD', '3'),
            ],
        })
    }

}
